import { getRequest } from '../api-handler';
import { InstrumentGroupDetailDto } from './instrumentgroup';

export const InstrumentGroupApi = {
  getById: (id: number) =>
    getRequest<InstrumentGroupDetailDto>(`/instrumentgroups/${id}`)
};
